module.exports = __webpack_public_path__ + "static/31-826ed0cca8b6935edbf87055e1a6f7d5.jpg";